import React, { useState } from "react";

const PasswordInput = ({
    name,
    value,
    placeholder,
    onChange,
    onBlur,
    maxLength = 15,
    minLength,
    marginClass = "mt-base",
    compareWith = null,
}) => {
    const [showPassword, setShowPassword] = useState(false);

    const shouldCompare = compareWith !== null;
    const hasValue = value !== "";
    const hasError =
        shouldCompare &&
        hasValue &&
        value !== compareWith;

    return (
        <>
            <div
                className={`password-input ${
                    hasError ? "password-input--error" : ""
                } ${marginClass}`}
            >
                <input
                    type={showPassword ? "text" : "password"}
                    autoComplete="off"
                    className="password-input__input"
                    placeholder={placeholder}
                    name={name}
                    maxLength={maxLength}
                    minLength={minLength}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                />

                <button
                    type="button"
                    onClick={() => setShowPassword(prev => !prev)}
                    className="password-input__toggle"
                >
                    <img
                        src={
                            showPassword
                                ? "/images/icons/eye-slashed.svg"
                                : "/images/icons/eye-visible.svg"
                        }
                        alt="Ver / ocultar contraseña"
                    />
                </button>
            </div>

            {hasError && (
                <p className="errorMsgInput">
                    Las contraseñas no coinciden
                </p>
            )}
        </>
    );
};

export default PasswordInput;
